import * as React from 'react';

import {GraphQLSelectIndustries} from '../../../core/select/graphql-select-industries';

export const INDUSTRY_SELECT_ID = 'industry-select-id';

type Props = {
    industryId: string | null | undefined;
    onUpdateIndustry: (industryId?: string | null | undefined) => void;
    isDisabled?: boolean;
    canAccessSetup: boolean;
};

export function AccountIndustrySelect(props: Props) {
    const {industryId, onUpdateIndustry, isDisabled, canAccessSetup} = props;

    // @ts-expect-error
    const onChangeIndustry = (selectedIndustry) => {
        if (isDisabled) return;

        if (selectedIndustry && selectedIndustry.id) {
            onUpdateIndustry(selectedIndustry.id);
        } else {
            onUpdateIndustry(null);
        }
    };

    return (
        <GraphQLSelectIndustries
            inputId={INDUSTRY_SELECT_ID}
            selectedId={industryId}
            onChange={onChangeIndustry}
            // @ts-expect-error
            onClearValue={onChangeIndustry}
            hasManageOption={canAccessSetup}
            hideDividerWhenEmpty={true}
            isDisabled={isDisabled}
        />
    );
}
